import { createInputHidden } from '../utils/common'
import { INPUT_HIDDEN_NAME } from '../utils/constants'

/**
 * 
 * @param {HTML element} container The container of each pills
 * @param {function} cb this is the send form function, so before send the form
 *                      check if the container is empty or not.
 * 
 * If User remove all the Pills we set an input Hidden without value
 * and send it to the backend in order to "clean and remove" the previus data
 */

const addInputHiddenWithEmptyValue = (cb, container) => {
  setTimeout( () => { // Giving some time to removePill function to handle the container items.
    if (container.children.length === 0) {
      switch(container.id) {
        case 'js-pills-skills-container':
          container.appendChild(createInputHidden(INPUT_HIDDEN_NAME.skills))
          break;
        case 'js-pills-expertises-container':
          container.appendChild(createInputHidden(INPUT_HIDDEN_NAME.expertises))
          break;
        case 'js-pills-area-container':
          container.appendChild(createInputHidden(INPUT_HIDDEN_NAME.continent))
          container.appendChild(createInputHidden(INPUT_HIDDEN_NAME.country))
          break;
      }
    }
    cb && cb();
  }, 300)
};

export default addInputHiddenWithEmptyValue;
